/* ==========================================================================
   PIRLONI STORE CARD
   Paints the open / closed badge and the week's hours from one table, on the
   shopper's own clock — so a cached page never claims the shop is open when
   it is not.
   ========================================================================== */
(function () {
  'use strict';

  /** "10:00" -> 10.0 ; "9:30" -> 9.5 ; anything else -> null (closed). */
  function toHours(value) {
    if (!value) return null;
    var parts = String(value).split(':');
    var h = parseInt(parts[0], 10);
    if (isNaN(h)) return null;
    var m = parts.length > 1 ? parseInt(parts[1], 10) : 0;
    return h + (isNaN(m) ? 0 : m) / 60;
  }

  function initStore(root) {
    if (root.getAttribute('data-pst-ready') === 'true') return;
    var node = root.querySelector('[data-pst-data]');
    if (!node) return;

    var data;
    try { data = JSON.parse(node.textContent); } catch (e) { return; }
    if (!data || !data.days || !data.days.length) return;
    root.setAttribute('data-pst-ready', 'true');

    var badge = root.querySelector('[data-pst-open]');
    var list = root.querySelector('[data-pst-hours]');

    // The table is written Monday first, the way a shopper reads it; JavaScript
    // counts from Sunday. This is the only place the two have to meet.
    function dayIndex(jsDay) { return (jsDay + 6) % 7; }

    function paint() {
      var now = new Date();
      var todayRow = dayIndex(now.getDay());
      var current = now.getHours() + now.getMinutes() / 60;

      var today = data.days[todayRow];
      var openAt = today ? toHours(today.open) : null;
      var closeAt = today ? toHours(today.close) : null;
      var isOpen = openAt !== null && closeAt !== null && current >= openAt && current < closeAt;

      if (badge) {
        var text;
        if (isOpen) {
          text = (data.openText || 'Open now · until [time]').replace('[time]', today.close);
        } else {
          // Later today if it has not opened yet, otherwise the next day that
          // actually has hours — a shop shut all week says nothing at all.
          var nextRow = todayRow;
          var nextDay = today;
          if (openAt !== null && closeAt !== null && current < openAt) {
            text = (data.closedText || 'Closed · opens [day] [time]')
              .replace('[day]', 'today').replace('[time]', today.open);
          } else {
            var tries = 0;
            do {
              nextRow = (nextRow + 1) % data.days.length;
              nextDay = data.days[nextRow];
              tries += 1;
            } while (tries < data.days.length && toHours(nextDay && nextDay.open) === null);

            if (toHours(nextDay && nextDay.open) === null) {
              text = '';
            } else {
              text = (data.closedText || 'Closed · opens [day] [time]')
                .replace('[day]', nextDay.name).replace('[time]', nextDay.open);
            }
          }
        }
        badge.textContent = text;
        badge.classList.toggle('is-shut', !isOpen);
        badge.hidden = text === '';
      }

      if (list) {
        list.innerHTML = data.days.map(function (day, i) {
          var hours = toHours(day.open) === null
            ? (day.close || 'Closed')
            : day.open + ' — ' + day.close;
          return '<div class="pst-hr' + (i === todayRow ? ' is-today' : '') + '">' +
            '<span>' + day.name + '</span><span>' + hours + '</span></div>';
        }).join('');
      }
    }

    paint();
    // Half a minute is enough to flip the badge the moment the shop opens or
    // shuts, without the page doing work nobody sees.
    window.setInterval(paint, 30000);
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-pst]').forEach(initStore);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();
